module.exports = __webpack_public_path__ + "static/media/Turkey.72e7b6a8.jpg";